// Men wardrobe style
// import MenCasualWear from "@/assets/images/MenWardrobeStyle/men-casual.png";
// import MenBusinessWear from "@/assets/images/MenWardrobeStyle/men-business.png";
// import MenTraditionalWear from "@/assets/images/MenWardrobeStyle/men-traditional.png";
// import MenSportsWear from "@/assets/images/MenWardrobeStyle/men-sports.png";

// Men skin tone
// import MenFairSkinned from "@/assets/images/MenSkinTone/fair-skinned-men.png";
// import MenBrownSkinned from "@/assets/images/MenSkinTone/brown-skinned-men.png";
// import MenDarkSkinned from "@/assets/images/MenSkinTone/dark-skinned-men.png";

// Men body type
// import AverageMenBody from "@/assets/images/MenBodyType/men-average-men.png";
// import SlimMenBody from "@/assets/images/MenBodyType/men-slim-men.png";
// import AthleticMenBody from "@/assets/images/MenBodyType/men-athletic-men.png";
// import PlusSizeMenBody from "@/assets/images/MenBodyType/men-plus-size-men.png";

// // Women body type
// import WomenAverage from "@/assets/images/WomenBodyType/women-average.png";
// import WomenAthletic from "@/assets/images/WomenBodyType/women-athletic.png";
// import WomenSlim from "@/assets/images/WomenBodyType/women-slim.png";
// import WomenPlusSize from "@/assets/images/WomenBodyType/women-plusSize.png";

// // womenmen wardrobe style
// import WomenCasualWear from "@/assets/images/WomenWarddrobeSyle/women-causal.png";
// import WomenBusinessWear from "@/assets/images/WomenWarddrobeSyle/women-buisness.png";
// import WomenTraditionalWear from "@/assets/images/WomenWarddrobeSyle/women-traditional.png";
// import WomenSportsWear from "@/assets/images/WomenWarddrobeSyle/women-sports.png";

// // women skin tone
// import WomenFairSkinned from "@/assets/images/WomenSkinTone/women-fair.png";
// import WomenBrownSkinned from "@/assets/images/WomenSkinTone/women-brown.png";
// import WomenDarkSkinned from "@/assets/images/WomenSkinTone/women-dark.png";

// // tone of video
// import Casual from "@/assets/videos/toneOfVideo/casual.mp4";
// import Dramatic from "@/assets/videos/toneOfVideo/dramatic.mp4";
// import Humorous from "@/assets/videos/toneOfVideo/humorous.mp4";
// import Professional from "@/assets/videos/toneOfVideo/professional.mp4";

// import DashboardIcon from "@/assets/icons/Dashboard.svg";
// import ProjectsIcon from "@/assets/icons/Projects.svg";
// import CalenderIcon from "@/assets/icons/Calender.svg";
// import TemplateIcon from "@/assets/icons/Template.svg";
// import MessagesIcon from "@/assets/icons/Messages.svg";
// import NotificationsIcon from "@/assets/icons/Notification.svg";
// import Orders from "@/pages/orders/orders";
// import Messages from "@/pages/messages/messages";
// import Calender from "@/pages/calender/calender";
// import Notifications from "@/pages/notifications/notifications";
import {
  PlanDetailsTypes,
  PreferredVideoTypesProps,
  SelectComponetOption,
  SidebarLink,
} from "@/types/types";
import WalletIcon from "@/assets/icons/PricingPlan.svg";
import InvoiceIcon from "@/assets/icons/Invoices.svg";
import SettingIcon from "@/assets/icons/Setting.svg";
import Question from "@/assets/icons/Question.svg";
// import Pricing from "@/pages/pricing/pricing";
// import Billing from "@/pages/billing/billing";
// import Help from "@/pages/help/help";
// import Setting from "@/pages/setting/setting";
// import Dashboard from "@/pages/dashboard/dashboard";

import JobsIcon from "@/assets/icons/JobsIcon.svg";

// import Style1Image from "@/assets/images/videoEditingDetails/style-1.png";
// import PotraitImag from "@/assets/images/videoEditingDetails/portrait.png";
// import LanscapeImg from "@/assets/images/videoEditingDetails/landscape.png";
// import HomeBg from "@/assets/images/videoEditingDetails/home-background.png";
// import VisualBg from "@/assets/images/videoEditingDetails/visual-background.png";
// import FileIcon from "@/assets/icons/File.svg";
// import NotesIcon from "@/assets/icons/Notes.svg";
// import Community from "@/pages/community/community";
import CommunityIcon from "@/assets/icons/Community.svg";

// import Templates from "@/pages/templates/templates";

// export const Preffered_Video_Types: PreferredVideoTypesProps[] = [
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/actor-driven.webp",
//     id: "actor_driven",
//     title: "Actor-Driven",
//     desc: "In these videos, Actor leads by performing, recording, and editing the video.",
//   },
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/editor-driven.webp",
//     id: "editor_driven",
//     title: "Editor-Driven",
//     desc: "In these videos, Editors use stock elements and voiceovers to create the final video.",
//   },
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/videographer-driven.webp",
//     id: "videoGrapher_driven",
//     title: "Videographer -Driven",
//     desc: "In these Videos, Videographers shoot products and brand videos and handle the editing.",
//   },
// ];

export const DefaultCompanyLogo =
  "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/deafult_company_logo.png";
export const Actor_Driven_Plans = [
  {
    videoType: "home-studio",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
    planName: "Home Studio",
    price: 3999,
    planPrice_in_text: "3999",
    description:
      "Unlock Professional marketing videos from home with our Actor-Driven Plan",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Own Home-studio environment",
      "Actor/Spokesperson",
      "Casual/Business Attire Options",
      "Home Studio (iPhone Quality)",
      "Standard Equipment",
      "Basic editing",
      "View Video Samples",
      "Choose Home - Studio",
    ],
    btnText: "Choose Home-Studio",
  },
  {
    videoType: "professional-studio",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/proffessional-studio.webp",
    planName: "Professional Studio",
    price: 17500,
    planPrice_in_text: "17,500",
    description:
      "Access Professional studio equipment for polished video production.",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Experienced Actor/Spokesperson",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "High-Quality Equipment",
      "Standard Editing",
      "View Video Samples",
      "Choose Professional - Studio",
    ],
    btnText: "Choose Professional-Studio",
  },
  {
    videoType: "multi-actor",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/multi-actor-cover.webp",
    planName: "Multi-Actor",
    planPrice_in_text: "35,000",
    price: 35000,
    description:
      "Engage with our Skit/Live Action plan featuring multiple action and live-action scenes",
    perfectFor: ["Brand Storytelling", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Professional Actor/Spokesperson",
      "Multiple Actors",
      "Studio Aesthetic",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "Enterprise grade editing",
      "View Video Samples",
      "Choose Multi-Actor",
    ],
    btnText: "Choose Multi-Actor",
  },
];

export const Editor_Driven_Plans = [
  {
    videoType: "stock-style-edits",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Stock-Style+Edits.webp",
    planName: "Stock-Style Edits",
    planPrice_in_text: "2499",
    price: 2499,
    description:
      "Get polished, professional videos with our Basic Editing services",
    perfectFor: ["Social media videos", "Marketing videos"],
    featureOverview: [
      "Unlimited stock images",
      "Brand Guidelines Alignment",
      "Basic color corrections",
      "Voice Over, Sound Effects and Music",
      "Basic editing",
      "Titles, Text captions and overlays",
    ],
    btnText: "Choose Stock - Style",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Stock-IllustrationFootage.webp",
    videoType: "stock-illustration-footage",
    planName: "Stock-Illustration/Footage",
    planPrice_in_text: "15,500",
    price: 15500,
    description:
      "Enhance and refine your videos with our Standard Editing services",
    perfectFor: ["Corporate Educational Videos", "Promotional Videos"],
    featureOverview: [
      "Illustrations and video footage.",
      "Brand Guidelines Alignment",
      "Enhanced Color Grading",
      "Audio Enhancements",
      "Standard animation effects",
      "Custom Intro & Outro",
    ],
    btnText: "Choose Stock - Illustration",
  },
  {
    videoType: "motion-graphics-3d",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Motion+Graphics3D.webp",
    planName: "Motion Graphics/3D",
    planPrice_in_text: "35,000",
    price: 35000,
    description:
      "Get Personalized videos with our Advanced/Custom Editing services",
    perfectFor: ["Commercial Videos", "Branded content"],
    featureOverview: [
      "Motion graphics elements",
      "Brand Guidelines Alignment",
      "Professional Color Grading",
      "License-Free Music and Sound effects",
      "Advanced animation and 3d effects",
      "Custom Intro & Outro",
    ],
    btnText: "Choose Motion Graphics / 3D",
  },
];

export const VideoGrapher_Driven_Plans = [
  {
    videoType: "budget-shoot",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Budget+Shoot.webp",
    planName: "Budget Shoot",
    planPrice_in_text: "7,999",
    price: 7999,
    description:
      "Affordable, high-quality videos perfect for startups and small businesses",
    perfectFor: ["Testimonial Videos", "Product Shoots"],
    featureOverview: [
      "Video Duration of 2-3 mins",
      "Basic lighting setup",
      "Simple/Greenscreen background",
      "Standard audio recordings",
      "Basic Editing",
      "Questionnaire Preparation",
    ],
    btnText: "Choose Budget",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Cinematic+shoot.webp",
    videoType: "cinematic-shoot",
    planName: "Cinematic shoot",
    planPrice_in_text: "25,000",
    price: 25000,
    description:
      "Professional-grade video production for a polished, cinematic look",
    perfectFor: ["Testimonial Videos", "Product Shoots"],
    featureOverview: [
      "Video Duration of 2-3 mins",
      "Advanced lighting setup",
      "Customized Background/ Studio/ Green screen",
      "High-Quality audio recording",
      "Enterprise Grade Editing",
      "Multi-Camera Angles",
      "Questionnaire Preparation",
      "1 Free Micro-Content Clip (Under 1 min)",
    ],
    btnText: "Choose Cinematic",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Cinematic-Extended+Shoot.webp",
    videoType: "cinematic-extended-shoot",
    planName: "Cinematic-Extended Shoot",
    planPrice_in_text: "45,000",
    price: 450000,
    description:
      "Extended cinematic storytelling for detailed narratives and in-depth projects",
    perfectFor: ["Case Study Videos", "Product Descriptions"],
    featureOverview: [
      "Video Duration of 3-5 mins",
      "Professional lighting setup",
      "Customized Background/ Studio/ Green screen",
      "High-Quality microphones (noise reduction)",
      "Enterprise Grade Editing",
      "Multi-Camera Angles",
      "2 Free Micro-Content Clip (Under 1 min)",
      "B-Roll Shoot",
      "Make-up Artist",
    ],
    btnText: "Choose Cinematic - Extended",
  },
];

// export const SidebarLinks: SidebarLink[] = [
//   {
//     icon: <DashboardIcon />,
//     element: <Dashboard />,
//     label: "Dashboard",
//     path: "dashboard",
//     isNew: false,
//   },
//   {
//     icon: <ProjectsIcon />,
//     element: <Projects />,
//     label: "Projects",
//     path: "projects",
//     isNew: false,
//   },
//   {
//     icon: <JobsIcon />,
//     element: <Jobs />,
//     label: "Jobs for you",
//     path: "jobs",
//     isNew: false,
//   },
//   {
//     icon: <DashboardIcon />,
//     element: <Profile />,
//     label: "Profile",
//     path: "profile",
//     isNew: false,
//   },
//   {
//     icon: <NotificationsIcon />,
//     element: <Notifications />,
//     label: "Notification",
//     path: "notification",
//     isNew: false,
//   },
// ];
// export const MobileBottomNav: SidebarLink[] = [
//   {
//     icon: <DashboardIcon />,
//     element: <Dashboard />,
//     label: "Dashboard",
//     path: "/dashboard",
//   },
//   {
//     icon: <JobsIcon />,
//     element: <Jobs />,
//     label: "Jobs",
//     path: "/jobs",
//   },
//   {
//     label: "Project",
//     icon: <ProjectsIcon />,
//     element: <Projects />,
//     path: "/projects",
//   },
//   {
//     icon: <WalletIcon />,
//     element: <Wallet />,
//     label: "Wallet",
//     path: "/wallet",
//   },
// ];
// export const OtherLinks: SidebarLink[] = [
//   {
//     icon: <WalletIcon />,
//     element: <Wallet />,
//     label: "Wallet",
//     path: "wallet",
//   },
//   // {
//   //   icon: <InvoiceIcon />,
//   //   element: <Dashboard />,
//   //   label: "Billing and Invoices",
//   //   path: "billings",
//   // },
// ];

export const DEFAULT_IMAGE_PLACEHOLDER =
  "https://d3ovm7e6af2kt4.cloudfront.net/public/client-dashboard/images/image-placeholder.jpg";

export const FeatureFlagsConstants = {
  AI_MARKET_PLACE: "ai-market-place",
};

export const PersonalLinks: SidebarLink[] = [
  // {
  //   icon: <SettingIcon />,
  //   element: <Setting />,
  //   label: "Setting",
  //   path: "setting",
  // },
  // {
  //   icon: <Question />,
  //   element: <Help />,
  //   label: "Help and Feedback",
  //   path: "help",
  // },
];
export const DistributionOptions = [
  {
    id: "social-media",
    title: "Social media",
  },
  {
    id: "company-Website",
    title: "Company Website",
  },

  {
    id: "youtube",
    title: "Youtube",
  },
  {
    id: "meta/googleads",
    title: "Meta / Google Ads",
  },
  {
    id: "others",
    title: "Others",
  },
];
export const targetAudienceOptions = [
  { id: "1", title: "Adults" },
  { id: "2", title: "Teens" },
  { id: "3", title: "Children" },
  { id: "4", title: "Seniors" },
  { id: "5", title: "Professionals" },
];
export const LanguageOptions = [
  { id: "1", title: "English" },
  { id: "112", title: "Hindi" },
  { id: "2", title: "Bengali" },
  { id: "3", title: "Telugu" },
  { id: "4", title: "Marathi" },
  { id: "5", title: "Tamil" },
  { id: "6", title: "Gujarati" },
  { id: "7", title: "Urdu" },
  { id: "8", title: "Kannada" },
  { id: "9", title: "Odia" },
  { id: "10", title: "Punjabi" },
];

export const HaveAScriptOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No, I need help",
  },
];

export const PrimaryGoalOptions = [
  "Promoting a Product / Service",
  "Entertain",
  "Educate (Or) Inform Audience",
  "Others",
];

// export const ToneOfVideoOptions = [
//   {
//     video: true,
//     title: "Professional",
//     url: Professional,
//   },
//   {
//     video: true,
//     title: "Casual",
//     url: Casual,
//   },
//   {
//     video: true,
//     title: "Dramatic",
//     url: Dramatic,
//   },
//   {
//     video: true,
//     title: "Humorous",
//     url: Humorous,
//   },
//   {
//     video: false,
//     title: "Others",
//   },
// ];

export const DeliverySlotOptions = [
  {
    days: 7,
    title: "5-8 Working Days",
    desc: "Standard Delivery",
    extraCharge: 0,
  },

  {
    days: 3,
    title: "72 Hours (3 Working Days)",
    desc: `Express Delivery  •  50% of the order value`,
    extraCharge: 50,
  },
];

// export const FormatOptions = [
//   {
//     img: PotraitImag,
//     title: "Portrait (9:16)",
//   },
//   {
//     img: LanscapeImg,
//     title: "Landscape (16:9)",
//   },
// ];

// export const VideoBgOptions = [
//   {
//     img: HomeBg,
//     title: "Home Background",
//   },
//   {
//     img: VisualBg,
//     title: "Visual background",
//   },
// ];

// export const AdditionaInfoOptions = [
//   {
//     id: "1",
//     icon: <NotesIcon />,
//     title: "Add Notes",
//   },
//   {
//     id: "2",
//     icon: <FileIcon />,
//     title: "Upload files & Links",
//   },
// ];

export const YesOrNoOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No",
  },
];

// export const videoEditStyle = [
//   {
//     img: Style1Image,
//     title: "Picture - In - Picture",
//     desc: " Live Product Demonstration Where Actor and Visuals happen in Same Frame",
//   },
//   {
//     img: Style1Image,
//     title: "Actor and Visual Movement",
//     desc: "Actor-focused with basic visuals and minimal edits.",
//   },
//   {
//     img: Style1Image,
//     title: "Stock Video with Voiceover",
//     desc: "The actor narrates over stock footage.",
//   },
//   {
//     img: Style1Image,
//     title: "Live Product Demonstration",
//     desc: "The actor showcases the product live.",
//   },
// ];

// export const MenBodyTypeOptions = [
//   {
//     id: "1",
//     img: AverageMenBody,
//     title: "Average",
//   },
//   {
//     id: "2",
//     img: SlimMenBody,
//     title: "Slim",
//   },
//   {
//     id: "3",
//     img: AthleticMenBody,
//     title: "Athletic",
//   },
//   {
//     id: "4",
//     img: PlusSizeMenBody,
//     title: "Plus-Size",
//   },
//   {
//     id: "5",
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
//     title: "No Preferences",
//   },
// ];

// export const MenSkinToneOptions = [
//   {
//     id: "1",
//     img: MenFairSkinned,
//     title: "Fair-Skinned",
//   },
//   {
//     id: "2",
//     img: MenBrownSkinned,
//     title: "Brown-Skinned",
//   },
//   {
//     id: "3",
//     img: MenDarkSkinned,
//     title: "Dark-Skinned",
//   },

//   {
//     id: "5",
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
//     title: "No Preferences",
//   },
// ];

// export const WomenBodyTypeOptions = [
//   {
//     id: "1",
//     img: WomenAverage,
//     title: "Average",
//   },
//   {
//     id: "2",
//     img: WomenSlim,
//     title: "Slim",
//   },
//   {
//     id: "3",
//     img: WomenAthletic,
//     title: "Athletic",
//   },
//   {
//     id: "4",
//     img: WomenPlusSize,
//     title: "Plus-Size",
//   },
//   {
//     id: "5",
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
//     title: "No Preferences",
//   },
// ];
// export const WomenSkinToneOptions = [
//   {
//     id: "1",
//     img: WomenFairSkinned,
//     title: "Fair-Skinned",
//   },
//   {
//     id: "2",
//     img: WomenBrownSkinned,
//     title: "Brown-Skinned",
//   },
//   {
//     id: "3",
//     img: WomenDarkSkinned,
//     title: "Dark-Skinned",
//   },

//   {
//     id: "5",
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
//     title: "No Preferences",
//   },
// ];
import OrdersIcon from "@/assets/icons/Orders.svg";
import TemplateIcon from "@/assets/icons/Template.svg";
import NotificationsIcon from "@/assets/icons/Notification.svg";
import PricingIcon from "@/assets/icons/PricingPlan.svg";

export const SidebarLinks: SidebarLink[] = [
  // {
  //   icon: <DashboardIcon />,
  //   element: <Dashboard />,
  //   label: "Dashboard",
  //   path: "dashboard",
  //   isNew: false,
  // },
  {
    icon: <OrdersIcon />,
    // element: <Orders />,
    label: "Orders",
    path: "orders",
    isNew: false,
    isExternalRedirect: true,
  },
  {
    isExternalRedirect: true,

    icon: <TemplateIcon />,
    // element: <Templates />,
    label: "Templates",
    path: "templates",
    isNew: true,
  },
  // {
  //   icon: <MessagesIcon />,
  //   element: <Messages />,
  //   label: "Messages",
  //   path: "messages",
  // },
  // {
  //   icon: <CalenderIcon />,
  //   element: <Calender />,
  //   label: "Calender",
  //   path: "calender",
  // },
  {
    isExternalRedirect: true,

    icon: <NotificationsIcon />,
    label: "Notifications",
    // element: <Notifications />,
    path: "notifications",
    isNew: false,
  },
];
import IncoiveIcon from "@/assets/icons/Invoices.svg";
import AiPricing from "@/pages/aiPricing/aiPricing";

export const OtherLinks: SidebarLink[] = [
  // {
  //   icon: <PricingIcon />,
  //   // element: <Pricing />,
  //   label: "Pricing",
  //   path: "pricing",
  //   isExternalRedirect: true,
  // },
  {
    icon: <PricingIcon />,
    element: <AiPricing />,
    label: "Pricing",
    path: "pricing",
    isExternalRedirect: false,
  },
  {
    isExternalRedirect: true,
    icon: <IncoiveIcon />,
    // element: <Billing />,
    label: "Billing and Invoices",
    path: "billings",
  },
];

export const orderButtonRoutes = [
  "/",
  "/dashboard",
  "/orders",
  "/pricing",
  "/billings",
];
export const desktopHeaderRoutes = ["/", "/dashboard", "/pricing", "/orders"];
export const mobileHeaderRoutes = [
  "/",
  "/dashboard",
  "/pricing",
  "/billings",
  "/billing-settings",
  "/billing-settings",
  "/settings",
  "/orders",
  "/notifications",
];

export const hideMobileBottomNavRoutes = [
  "/orders/create-order/plan-selection",
  "/orders/create-order/actor-and-video-details",
  "/orders/create-order/order-summary",
  "/orders/order-management",
  "/templates/create-order/video-brief",
  "/templates/create-order/creator-selection",
  "/templates/create-order/video-editing",
  "/templates/create-order/order-summary",
];
export const hideSideBarRoutes = [
  "/orders/create-order/plan-selection",
  "/orders/create-order/actor-and-video-details",
  "/orders/create-order/order-summary",
  "/orders/order-management",
  "/templates/create-order/video-brief",
  "/templates/create-order/creator-selection",
  "/templates/create-order/video-editing",
  "/templates/create-order/order-summary",
];

export const PersonaStylesOptions = [
  "Casual",
  "Professional",
  "Formal",
  "Semi-formal",
  "Others",
];

// export const WomenWardrobStyleOptions = [
//   {
//     active: true,
//     id: "1",
//     img: WomenCasualWear,
//     title: "Casual Wear",
//   },
//   {
//     id: "2",
//     img: WomenBusinessWear,
//     title: "Business attire",
//   },
//   {
//     id: "3",
//     img: WomenTraditionalWear,
//     title: "Traditional attire",
//   },
//   {
//     id: "4",
//     img: WomenSportsWear,
//     title: "Sports attire",
//   },
// ];

// export const MenWardrobStyleOptions = [
//   {
//     active: true,
//     id: "1",
//     img: MenCasualWear,
//     title: "Casual Wear",
//   },
//   {
//     id: "2",
//     img: MenBusinessWear,
//     title: "Business attire",
//   },
//   {
//     id: "3",
//     img: MenTraditionalWear,
//     title: "Traditional attire",
//   },
//   {
//     id: "4",
//     img: MenSportsWear,
//     title: "Sports attire",
//   },
// ];

export const countryOptions = [
  { value: "+1", label: "US" },
  { value: "+33", label: "FR" },
  { value: "+44", label: "UK" },
  { value: "+91", label: "IN" },
  { value: "+93", label: "AF" },
  { value: "+355", label: "AL" },
  { value: "+213", label: "DZ" },
  { value: "+376", label: "AD" },
  { value: "+244", label: "AO" },
  { value: "+672", label: "AQ" },
  { value: "+54", label: "AR" },
  { value: "+374", label: "AM" },
  { value: "+297", label: "AW" },
  { value: "+61", label: "AU" },
  { value: "+43", label: "AT" },
  { value: "+994", label: "AZ" },
  { value: "+973", label: "BH" },
  { value: "+880", label: "BD" },
  { value: "+375", label: "BY" },
  { value: "+32", label: "BE" },
  { value: "+501", label: "BZ" },
  { value: "+229", label: "BJ" },
  { value: "+975", label: "BT" },
  { value: "+591", label: "BO" },
  { value: "+387", label: "BA" },
  { value: "+267", label: "BW" },
  { value: "+55", label: "BR" },
  { value: "+673", label: "BN" },
  { value: "+359", label: "BG" },
  { value: "+226", label: "BF" },
  { value: "+257", label: "BI" },
  { value: "+855", label: "KH" },
  { value: "+237", label: "CM" },
  { value: "+238", label: "CV" },
  { value: "+236", label: "CF" },
  { value: "+235", label: "TD" },
  { value: "+56", label: "CL" },
  { value: "+86", label: "CN" },
  { value: "+57", label: "CO" },
  { value: "+269", label: "KM" },
  { value: "+243", label: "CD" },
  { value: "+242", label: "CG" },
  { value: "+506", label: "CR" },
  { value: "+385", label: "HR" },
  { value: "+53", label: "CU" },
  { value: "+357", label: "CY" },
  { value: "+420", label: "CZ" },
  { value: "+45", label: "DK" },
  { value: "+253", label: "DJ" },
  { value: "+670", label: "TL" },
  // Additional European countries
  { value: "+372", label: "EE" },
  { value: "+358", label: "FI" },
  { value: "+49", label: "DE" },
  { value: "+30", label: "GR" },
  { value: "+36", label: "HU" },
  { value: "+353", label: "IE" },
  { value: "+39", label: "IT" },
  { value: "+371", label: "LV" },
  { value: "+370", label: "LT" },
  { value: "+352", label: "LU" },
  { value: "+31", label: "NL" },
  { value: "+48", label: "PL" },
  { value: "+351", label: "PT" },
  { value: "+40", label: "RO" },
  { value: "+7", label: "RU" },
  { value: "+381", label: "RS" },
  { value: "+421", label: "SK" },
  { value: "+386", label: "SI" },
  { value: "+34", label: "ES" },
  { value: "+46", label: "SE" },
  { value: "+41", label: "CH" },
  { value: "+380", label: "UA" },
  // Additional Asian countries
  { value: "+374", label: "AM" },
  { value: "+994", label: "AZ" },
  { value: "+973", label: "BH" },
  { value: "+880", label: "BD" },
  { value: "+673", label: "BN" },
  { value: "+86", label: "CN" },
  { value: "+852", label: "HK" },
  { value: "+91", label: "IN" },
  { value: "+62", label: "ID" },
  { value: "+98", label: "IR" },
  { value: "+964", label: "IQ" },
  { value: "+972", label: "IL" },
  { value: "+81", label: "JP" },
  { value: "+962", label: "JO" },
  { value: "+7", label: "KZ" },
  { value: "+965", label: "KW" },
  { value: "+996", label: "KG" },
  { value: "+856", label: "LA" },
  { value: "+961", label: "LB" },
  { value: "+960", label: "MV" },
  { value: "+976", label: "MN" },
  { value: "+95", label: "MM" },
  { value: "+977", label: "NP" },
  { value: "+968", label: "OM" },
  { value: "+92", label: "PK" },
  { value: "+974", label: "QA" },
  { value: "+966", label: "SA" },
  { value: "+65", label: "SG" },
  { value: "+82", label: "KR" },
  { value: "+94", label: "LK" },
  { value: "+963", label: "SY" },
  { value: "+66", label: "TH" },
  { value: "+90", label: "TR" },
  { value: "+971", label: "AE" },
  { value: "+998", label: "UZ" },
  { value: "+84", label: "VN" },
  { value: "+967", label: "YE" },
];

export const GenderOptions = ["Male", "Female", "Either"];
export const AgeGroupOptions = [
  // {
  //   disabled: true,
  //   label: `Kids (<span class='font-medium text-[#17457D]'>Coming soon</span>) `,
  // },
  {
    disabled: false,
    ageRange: {
      min: 13,
      max: 18,
    },
    label: "Teens (13-18 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 19,
      max: 29,
    },
    label: "Young Adults (19-29 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 30,
      max: 45,
    },
    label: "Adults (30-45 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 46,
      max: 60,
    },
    label: "Middle-Aged (46-60 years)",
  },
  // {
  //   disabled: true,
  //   label: `Seniors (<span class='font-medium text-[#17457D]'>Coming soon</span>) `,
  // },
];

export const OtherDetailOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No",
  },
];

export const Pricing_Plan_contents = [
  {
    planName: "Starter Plan",
    pricebyMonth: "₹35k",
    actualPrice: 35000,
    description: "For new and small businesses",
    creditsAllotted: "35,000",
    features: [
      "1000+ creators to choose from",
      "High-quality video output",
      "Full-time contact support",
      "Up to 2 revisions",
      "Home-Studio Plan at ₹3999/- with Discount",
    ],
    isPopular: false,
  },
  {
    planName: "Standard Plan",
    pricebyMonth: "₹85k",
    actualPrice: 85000,
    description: "For growing businesses",
    creditsAllotted: "85,000 + 4250  Extra 5%",
    extraCreditsPercentage: 5,
    features: [
      "Everything in Starter Plan",
      "Dedicated video marketing strategist",
      "Up to 3 revisions",
      "More value for money",
    ],
    isPopular: true,
  },

  {
    planName: "Enterprise Plan",
    pricebyMonth: "₹2.56L",
    actualPrice: 256000,
    description: "For large enterprises needing scalable solutions",
    creditsAllotted: "2,56,000 + Extra 10% ",
    extraCreditsPercentage: 10,
    features: [
      "Everything in Standard Plan",
      "High-quality video output",
      "Up to 4 revisions",
      "More value for money",
      `Faster delivery at no extra cost`,
      "Extensions on feedback and approval timelines",
    ],
    isPopular: false,
  },
];

type TPlanPricingStructure = {
  pricingType: "fixed" | "dynamic";
  fixedPrice?: number; // For fixed-price plans like Home Studio
  dynamicPricing?: {
    minDuration: number; // in seconds
    maxDuration: number | null; // in seconds or null for no upper bound
    pricePerMinute: number;
  }[]; // For dynamic pricing plans like Professional Studio
};

type TPlanDetails = {
  _id: string;
  videoType: string;
  image: string;
  planName: string;
  price: number;
  planPrice_in_text: string;
  description: string;
  perfectFor: string[];
  featureOverview: string[];
  btnText: string;
  pricingStructure: TPlanPricingStructure;
};

const homeStudioPlan: TPlanDetails = {
  _id: "66b43526c9315c880baa3c1d",
  videoType: "66b3832e9101b4496a359ded",
  image:
    "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
  planName: "Home Studio",
  price: 3999,
  planPrice_in_text: "3999",
  description:
    "Unlock Professional marketing videos from home with our Actor-Driven Plan",
  perfectFor: ["Spoke Person Videos", "Promotional Videos"],
  featureOverview: [
    "Own Home-studio environment",
    "Actor/Spokesperson",
    "Casual/Business Attire Options",
    "Home Studio (iPhone Quality)",
    "Standard Equipment",
    "Basic editing",
    "View Video Samples",
    "Choose Home - Studio",
  ],
  btnText: "Choose Home-Studio",
  pricingStructure: {
    pricingType: "fixed",
    fixedPrice: 3999,
  },
};

const professionalStudioPlan: TPlanDetails = {
  _id: "66b43526c9315c880baa3c1d",
  videoType: "66b3832e9101b4496a359ded",
  image:
    "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/professional-studio-cover.webp",
  planName: "Professional Studio",
  price: 0, // will be calculated based on duration
  planPrice_in_text: "Dynamic Pricing",
  description:
    "Unlock Professional marketing videos with top-tier studio quality",
  perfectFor: ["Corporate Videos", "Product Demos"],
  featureOverview: [
    "Professional Studio environment",
    "Actor/Spokesperson",
    "Business Attire Options",
    "4K Quality",
    "Advanced Equipment",
    "Pro editing",
    "View Video Samples",
    "Choose Professional Studio",
  ],
  btnText: "Choose Professional-Studio",
  pricingStructure: {
    pricingType: "dynamic",
    dynamicPricing: [
      { minDuration: 0, maxDuration: 90, pricePerMinute: 17500 },
      { minDuration: 91, maxDuration: 300, pricePerMinute: 14000 },
      { minDuration: 301, maxDuration: 420, pricePerMinute: 12000 },
      { minDuration: 421, maxDuration: null, pricePerMinute: 10500 },
    ],
  },
};

export const TempActorDrivenData: PlanDetailsTypes[] = [
  {
    _id: "66b43526c9315c880baa3c1d",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
    planName: "Home Studio",
    price: 3999,
    planPrice_in_text: "3999",
    description:
      "Unlock Professional marketing videos from home with our Actor-Driven Plan",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Own Home-studio environment",
      "Actor/Spokesperson",
      "Casual/Business Attire Options",
      "Home Studio (iPhone Quality)",
      "Standard Equipment",
      "Basic editing",
      "View Video Samples",
      "Choose Home - Studio",
    ],
    btnText: "Choose Home-Studio",
    pricingStructure: {
      pricingType: "fixed",
      fixedPrice: 3999,
    },
  },
  {
    _id: "66b43526c9315c880baa3c1e",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/proffessional-studio.webp",
    planName: "Professional Studio",
    price: 17500,
    planPrice_in_text: "17,500",
    description:
      "Access Professional studio equipment for polished video production.",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Experienced Actor/Spokesperson",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "High-Quality Equipment",
      "Standard Editing",
      "View Video Samples",
      "Choose Professional - Studio",
    ],
    btnText: "Choose Professional-Studio",
    pricingStructure: {
      pricingType: "dynamic",
      dynamicPricing: [
        { minDuration: 0, maxDuration: 90, pricePerMinute: 17500 },
        { minDuration: 91, maxDuration: 300, pricePerMinute: 14000 },
        { minDuration: 301, maxDuration: 420, pricePerMinute: 12000 },
        { minDuration: 421, maxDuration: null, pricePerMinute: 10500 },
      ],
    },
  },
  {
    comingSoon: true,
    _id: "66b43526c9315c880baa3c1f",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/multi-actor-cover.webp",
    planName: "Multi-Actor",
    price: 35000,
    planPrice_in_text: "35,000",
    description:
      "Engage with our Skit/Live Action plan featuring multiple action and live-action scenes",
    perfectFor: ["Brand Storytelling", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Professional Actor/Spokesperson",
      "Multiple Actors",
      "Studio Aesthetic",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "Enterprise grade editing",
      "View Video Samples",
      "Choose Multi-Actor",
    ],
    btnText: "Choose Multi-Actor",
    pricingStructure: {
      pricingType: "fixed",
      fixedPrice: 3999,
    },
  },
];

export const skinTone: SelectComponetOption[] = [
  { id: "Fair-Skinned", title: "Fair-Skinned" },
  { id: "Brown-Skinned", title: "Brown-Skinned" },
  { id: "Dark-Skinned", title: "Dark-Skinned" },
  { id: "No Preference", title: "No Preference" },
];

export const bodyType: SelectComponetOption[] = [
  { id: "Average", title: "Average" },
  { id: "Slim", title: "Slim" },
  { id: "Athletic", title: "Athletic" },
  { id: "Plus-Size", title: "Plus-Size" },
  { id: "No Preferences", title: "No Preferences" },
];

export const videoShootingPropsOptions: SelectComponetOption[] = [
  { id: "Gadgets", title: "Gadgets (Extra Phone, Laptop, Tablet, etc)" },
  { id: "Utilities", title: "Utilities (Hairdryer, Table, Mirror, etc)" },
  { id: "Pets", title: "Pet(s)" },
  { id: "Vehicles", title: "Vehicle(s)" },
  { id: "Peer_Actor", title: "Peer actor/presenter" },
  { id: "Kitchen", title: "Kitchen - Cooking/Recipe reviews" },
];
